import { gql } from "@apollo/client";

const USER_TOURNAMENTS_RESULTS = gql`
  query userTournamentsResult($userId: Int) {
    userTournamentsResult(userId: $userId) {
      tournaments {
        id
        title
        league {
          league {
            sports {
              id
              title
            }
          }
        }
        tournamentCategory {
          category {
            name
            id
          }

          id
        }
        country
        startDate
        endDate
        timeZone
      }
    }
  }
`;

export default USER_TOURNAMENTS_RESULTS;
